import React from "react";
// ANT DESIGN COMPONENTS
import { Table, InputNumber } from "antd";
// FILTERS
import FilterSearchText from "../filters/FilterSearchText";
// INTERFACES
import { FormularyHeaderInputNumberInterface } from "../../../interfaces/Global.interface";

export default function FormularyHeaderInputNumber({
  columnName,
  inputPlaceholder,
  formAction,
  value,
  onChangeFormValue,
  variableName,
  itemId,
  onClickCellName = () => {},
  enabledCellClick = false,
  enabledFilter = false,
  filterValue = "",
  setFilterValue = () => {},
  refreshTable = () => {},
  disableCreateRow = false,
}: FormularyHeaderInputNumberInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Column, ColumnGroup } = Table;

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <ColumnGroup title={columnName}>
      <Column
        className="generalStyles__hoverCursor"
        onCell={(record: any) => ({
          onClick: () => {
            if (enabledCellClick && (disableCreateRow || formAction === "create")) {
              onClickCellName(record);
            }
          },
        })}
        filterDropdown={() => (
          <>
            {enabledFilter && (
              <FilterSearchText
                placeHolder={inputPlaceholder}
                filterValue={filterValue}
                setFilterValue={setFilterValue}
                refreshTable={refreshTable}
                refreshRequireParamenters
              />
            )}
          </>
        )}
        filterIcon={enabledFilter ? undefined : () => null}
        title={
          disableCreateRow ? (
            columnName
          ) : (
            <InputNumber
              size="small"
              placeholder={inputPlaceholder}
              value={formAction === "create" ? value : ""}
              disabled={formAction === "edit"}
              onChange={(event: any) => onChangeFormValue(event, variableName)}
            />
          )
        }
        dataIndex={variableName}
        key={variableName}
        render={(text, record: any) => (
          <div>
            {formAction === "edit" && record.id === itemId ? (
              <InputNumber
                size="small"
                placeholder={inputPlaceholder}
                value={value}
                onChange={(event: any) => {
                  onChangeFormValue(event, variableName);
                }}
              />
            ) : (
              <div>{text}</div>
            )}
          </div>
        )}
      />
    </ColumnGroup>
  );
}
